// Two board-local icons in the house Icon idiom (src/app/Icon.tsx is read-only this run and carries
// no back/play glyph): 24×24 inline stroke SVG, strokeWidth 1.7, currentColor, aria-hidden — sized by
// the caller, toned by the surrounding text colour (G-181). Paths mirror the approved prototype
// (docs/design/work-hifi/work.js `I.back` / `I.play`). No emoji anywhere.

export function BackIcon({ size = 16 }: { readonly size?: number }): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M15 6l-6 6 6 6" />
    </svg>
  );
}

export function PlayIcon({ size = 16 }: { readonly size?: number }): React.JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M7 5l12 7-12 7z" />
    </svg>
  );
}
